import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import styled from './styled';

class UserNewsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      debug: false,
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handlePrimaryButtonClick = (event) => {
    event.preventDefault();
    const { currentNews, onMarkAsRead, onAction, onClose } = this.props;
    if (currentNews && currentNews.id) {
      onMarkAsRead(currentNews.id);
    }
    if (onAction && currentNews) {
      onAction(currentNews);
    }
    if (onClose) {
      onClose();
    }
  };

  handleSecondaryButtonClick = (event) => {
    event.preventDefault();
    const { currentNews, onMarkAsRead, onClose } = this.props;
    if (currentNews && currentNews.id) {
      onMarkAsRead(currentNews.id);
    }
    if (onClose) {
      onClose();
    }
  };

  handleClose = (event) => {
    event.preventDefault();
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { currentNews } = this.props;
    if (!currentNews) {
      return null;
    }
    const {
      title,
      content,
      action_button_title,
      close_button_title,
      pill_label, // optional, for pill at top
    } = currentNews;

    return (
      <styled.WinContainerModern>
        <styled.HeaderRow>
          <styled.BlueDot />
          {pill_label && <styled.PillLabel>{pill_label}</styled.PillLabel>}
          <styled.CloseButton onClick={this.handleClose} aria-label="Close">×</styled.CloseButton>
        </styled.HeaderRow>
        {title && <styled.Heading>{title}</styled.Heading>}
        {content && <styled.BodyText>{content}</styled.BodyText>}
        <styled.ButtonsWrapper>
          {action_button_title && (
            <styled.PrimaryButtonModern onClick={this.handlePrimaryButtonClick}>
              {action_button_title}
            </styled.PrimaryButtonModern>
          )}
          {close_button_title && (
            <styled.SecondaryButtonModern onClick={this.handleSecondaryButtonClick}>
              {close_button_title}
            </styled.SecondaryButtonModern>
          )}
        </styled.ButtonsWrapper>
      </styled.WinContainerModern>
    );
  }
}

UserNewsModal.propTypes = {
  currentNews: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    content: PropTypes.string,
    action_button_title: PropTypes.string,
    close_button_title: PropTypes.string,
    pill_label: PropTypes.string,
    url: PropTypes.string,
    link: PropTypes.string,
    action: PropTypes.string,
    location_id: PropTypes.number,
  }),
  onMarkAsRead: PropTypes.func.isRequired,
  onAction: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

export default injectIntl(UserNewsModal); 